<template>
  <el-select
    size="small"
    filterable
    clearable
    @change="handleChange"
    placeholder="请选择"
    :value="value"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.number"
      :value="item.number"
    ></el-option>
  </el-select>
</template>

<script>
import { serviceQuestList } from '@/service/getData'

export default {
  props: {
    value: {
      type: String,
    },
    customerid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    async requestData() {
      let data = {
        page: 0,
        size: 20,
        customer_id: this.customerid,
        business_chance: true,
      }
      let res = await serviceQuestList(data)
      this.lists = res.data.list
    },
    handleChange(val) {
      this.$emit('input', val)
    },
  },
}
</script>